import { apiClient, ApiResult } from "@/lib/api-client"
import type {
  EmailTemplateDto,
  EmailTemplatePreviewDto,
} from "../dtos/email-templates-dto"

const base = (orgId: string) => `/organizations/${orgId}/email-templates`

export async function getEmailTemplates(
  orgId: string,
): Promise<EmailTemplateDto[]> {
  const res = await apiClient.get<ApiResult<EmailTemplateDto[]>>(base(orgId))
  return res.data.value
}

export async function upsertEmailTemplate(
  orgId: string,
  type: string,
  body: string,
): Promise<void> {
  await apiClient.put(`${base(orgId)}/${type}`, { body })
}

export async function deleteEmailTemplateOverride(
  orgId: string,
  type: string,
): Promise<void> {
  await apiClient.delete(`${base(orgId)}/${type}`)
}

export async function previewEmailTemplate(
  orgId: string,
  type: string,
  body?: string,
): Promise<EmailTemplatePreviewDto> {
  const res = await apiClient.get<ApiResult<EmailTemplatePreviewDto>>(
    `${base(orgId)}/${type}/preview`,
    { params: body ? { body } : undefined },
  )
  return res.data.value
}
